<div class="attr-tile" (click)="onClick()">
  <app-attraction-image class="attr-tile-image" [url]="imageUrl" [alt]="attraction.title || ''"></app-attraction-image>
  <h4 class="attr-tile-title">{{ attraction.title }}</h4>
  <app-attraction-rating-row class="attr-tile-rating"
    [rating]="attraction.rating" [reviewCount]="attraction.review_count" [compact]="true">
  </app-attraction-rating-row>
  <div class="attr-tile-price" *ngIf="price">{{ 'attractions.fromPrice' | translate:{ price: price } }}</div>
</div>
